import { type Country, type FoundedCountry } from '@/shared/types/api.types'
import { CountriesService } from './CountriesService'
import getUaeCountriesResponse from '@/shared/tests/mocks/responses/getuaecountries.json'
import findUaeCountriesResponse from '@/shared/tests/mocks/responses/findcountries.json'

export class CountriesServiceMock extends CountriesService {
  getUaeCountries(): Promise<Country[]> {
    // @ts-ignore
    return Promise.resolve(getUaeCountriesResponse.countries)
  }

  findUaeCountries(): Promise<FoundedCountry[]> {
    // @ts-ignore
    return Promise.resolve(findUaeCountriesResponse.list as FoundedCountry[])
  }
}
